/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Image_Viewer_PromptInputs */



/**
* | output |
* | --- |
* | "Prompt" |
*
* @param {Chat_Image_Viewer_PromptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_image_viewer_prompt = /** @type {((inputs?: Chat_Image_Viewer_PromptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Image_Viewer_PromptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prompt")
	return /** @type {LocalizedString} */ ("Prompt")
});